module.exports = __webpack_public_path__ + "img/hh.ca44b2d4.png";